import rank from './rank/'
import message from './message'
import post from './post'
import easemob from './easemob'
import wallet from './wallet'
import currency from './currency'
import question from './question'
import news from './news'
import group from './group'
import feed from './feed'
import user from './user'
import topic from './topic'

export default {
  rank,
  post,
  message,
  easemob,
  wallet,
  currency,
  question,
  news,
  group,
  feed,
  user,
  topic,
}
